(function () {
	'use strict';

	/*global angular*/
	var app = angular.module('cccu.photoUpload.preview', ['ui.router', 'cccu.photoUpload.services']);

	app.config(function ($stateProvider) {
		$stateProvider.state('preview', {
			url: '/preview',
			views: {
				'main': {
					controller: 'PreviewController',
					templateUrl: 'preview/index.html'
				}
			},
			data: {
				pageTitle: 'Smartcard Preview'
			}
		});
	});

	app.controller('PreviewController', ['$scope', '$state', '$log', 'photoUploadService', function ($scope, $state, $log, photoUploadService) {

	    // link the photo data from the property in the photoUploadSerice	    
	    $scope.photo = photoUploadService.photo;
	    $scope.backCta = 'Back';
	    $scope.nextCta = 'Next';
	    if ($scope.photo == null) {
	        $state.go('upload');
	    }
		$scope.next = function () {
		    $state.go('confirm');
		};

		$scope.back = function () {
		    $state.go('upload');
		};

        
    }]);
}());